import classNames from "classnames";
import React from "react";

export default function Loader({ className = "", size = 1 }: { className?: string, size?: number }) {
  return <i className={classNames("pi pi-spin pi-spinner", className)} style={{'fontSize': `${size}em`}}></i>
}